/**
 * Created by henriquemasca on 7/23/19.
 * Changed by gustavolemos on 9/11/19.
 */
import axios  from 'axios';
import Const from './consts';
import BasicService from './basic.service';


class ApiDeposit extends BasicService {
	
		// 'https://teste-hdm-dot-winvite-io.appspot.com/v1/deposit'
    api = Const.api + Const.path.deposit;

    postDeposit(transaction) {
    	
	    console.log('Headers postDeposit: ', axios.defaults.headers);
      return axios.post(this.api, transaction);
    }
}

export default new ApiDeposit();


// WEBPACK FOOTER //
// ./src/utils/api.deposit.js